import FundSubscriberConsumerPurchasedDataUnits from "./FundSubscriberConsumerPurchasedDataUnits";

const FundSubscriberDataConsumersProviderMain={
     FundSubscriberConsumerPurchasedDataUnits
}
export default FundSubscriberDataConsumersProviderMain
